import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../images/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (sectionId) => {
    toggleMenu();
    if (location.pathname !== '/') {
      navigate(`/#${sectionId}`);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        const defaultOffset = 50;
        const sobreNosOffset = 110;
        const offset = sectionId === 'sobre-nos' ? sobreNosOffset : defaultOffset;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    handleNavClick('home');
  };

  return (
    <header className="header">
      <div className="logo-container">
        <a href="/#home" onClick={handleLogoClick}>
          <img src={logo} alt="FluenciA Logo" className="logo" />
        </a>
        <p 
          style={{ color: '#221D34', fontSize: '1.5rem', fontWeight: 700, marginLeft: 10, cursor: 'pointer' }} 
          onClick={handleLogoClick}
        >
          FluencIA
        </p>
      </div>
      <button className="menu-toggle" onClick={toggleMenu}>
        {isMenuOpen ? '✕' : '☰'}
      </button>
      <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
        <ul className="nav-list">
          <li>
            <a
              href="/#home"
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('home');
              }}
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="/#beneficios"
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('beneficios');
              }}
            >
              Benefícios
            </a>
          </li>
          <li>
            <a
              href="/#certificados"
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('certificados');
              }}
            >
              Certificados
            </a>
          </li>
          <li>
            <a
              href="/#metodologia"
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('metodologia');
              }}
            >
              Metodologia
            </a>
          </li>
          <div className="action-buttons-mobile">
            <button className="entrar-btn">Entrar</button>
            <button className="testar-gratis-btn">Testar Grátis <span className="arrow">→</span></button>
          </div>
        </ul>
      </nav>
      <div className="action-buttons">
        <button className="entrar-btn">Entrar</button>
        <button className="testar-gratis-btn">Testar Grátis <span className="arrow">→</span></button>
      </div>
    </header>
  );
};

export default Header;
